import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, CONTACTS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allContact',
  url: `${CONTACTS_URL}/all/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
